import {
	CATEGORIES_GET_STATUS,
	CATEGORIES_GET,
	CATEGORIES_GET_ERROR,
	CATEGORIES_GET_BY_ID,
	CATEGORIES_CLEAR,
	CATEGORY_GET_STATUS,
	CATEGORY_GET,
	CATEGORY_GET_ERROR,
	CATEGORY_RESOURCES_GET_STATUS,
	CATEGORY_RESOURCES_GET,
	CATEGORY_RESOURCES_GET_ERROR,
	BREAD_CRUMBS_SET,
	BREAD_CRUMBS_SET_STATUS,
	RESOURCE_GET,
	RESOURCE_GET_ERROR,
	RESOURCE_CLEAR,
	RESOURCE_TOGGLE_VIEW,
} from './types'

const initialState = {
	isLoading: false,
	list: [],
	total: 0,
	resource: null,

	listMeta: null,
	singleMeta: null,

	breadCrumbs: [],

	category: null,
	categoryResources: [],
	listView: false,

	errors: null,
}

export const state = { ...initialState }

export default {
	[CATEGORIES_GET_STATUS]: (state, status) => {
		state.isLoading = status
	},
	[CATEGORY_GET_STATUS]: (state, status) => {
		state.isLoading = status
	},
	[BREAD_CRUMBS_SET_STATUS]: (state, status) => {
		state.isLoading = status
	},
	[CATEGORY_RESOURCES_GET_STATUS]: (state, status) => {
		state.isLoading = status
	},

	[BREAD_CRUMBS_SET]: (state, items) => {
		state.breadCrumbs = [...state.breadCrumbs, ...items]
	},

	[CATEGORIES_GET]: (state, { data, pageCount, perPage, totalCount, currentPage }) => {
		state.list = data

		state.listMeta = {
			pageCount,
			perPage,
			totalCount,
			currentPage,
		}
	},
	[CATEGORIES_GET_BY_ID]: (state, { data, pageCount, perPage, totalCount, currentPage }) => {
		state.list = data

		state.singleMeta = {
			pageCount,
			perPage,
			totalCount,
			currentPage,
		}
	},
	[CATEGORIES_CLEAR]: (state) => {
		state.list = []
	},
	[CATEGORY_GET]: (state, { data, pageCount, perPage, totalCount, currentPage }) => {
		state.category = data

		state.singleMeta = {
			pageCount,
			perPage,
			totalCount,
			currentPage,
		}
	},
	[CATEGORY_RESOURCES_GET]: (state, resources) => {
		state.categoryResources = resources
	},

	[CATEGORY_RESOURCES_GET_ERROR]: (state, errors) => {
		state.errors = errors
	},
	[CATEGORY_GET_ERROR]: (state, errors) => {
		state.errors = errors
	},
	[CATEGORIES_GET_ERROR]: (state, errors) => {
		state.errors = errors
	},
	[RESOURCE_GET]: (state, resource) => {
		state.resource = resource
	},
	[RESOURCE_CLEAR]: (state) => {
		state.resource = null
	},
	[RESOURCE_GET_ERROR]: (state, errors) => {
		state.errors = errors
	},
	[RESOURCE_TOGGLE_VIEW]: (state) => {
		state.listView = !state.listView
	},
}
